import { connect } from 'react-redux';
import * as mailingAddressActions from '../../redux/actions/mailingAddressActions';

export default (WrappedComponent) => connect(null, mailingAddressActions)(WrappedComponent);
